// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1T3YC","alertIcon":"ConfirmModal_alertIcon__fc-3m"};